import React from "react";

const SecuritySection = ({ t }) => (
  <section className="security anim-section home-section" id="seguridad">
    <div className="home-container">
      <div className="section-head">
        <h2>{t.security.head}</h2>
        <p>{t.security.sub}</p>
      </div>
      <div className="security-grid">
        {t.security.cards.map((card) => (
          <div className="security-card card-animated anim-card" key={card.title}>
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SecuritySection;
